
import { CommonStyles } from '../../common/react/CommonStyles';

export namespace ManageDataAlertRecipientsDialogStyles {

  export const STYLE: React.CSSProperties = {
      position: 'relative',
      height: '300px'
  };

  export const LIST_BOX_STYLE: React.CSSProperties = {
    borderWidth: CommonStyles.Sizes.TextBoxBorderSize,
    borderColor: CommonStyles.Colors.BorderColor,
    borderStyle: 'solid'
  };
}